export default __webpack_public_path__ + "static/media/no-data.921c39b4.svg";